/* eslint-disable */
export default (typeof global !== 'undefined'
  ? global
  : typeof window !== 'undefined' ? window : {});
